import { StaffsActionTypes, AccountModalMode, StaffRequest } from './Types';
import { Feature } from '../account/Types';
import { FEATURES, NONE, READ, BUSINESS } from '../account/Constants';

export const REGISTER_STAFF: StaffsActionTypes = 'REGISTER_STAFF';
export const UPDATE_STAFF: StaffsActionTypes = 'UPDATE_STAFF';
export const DELETE_STAFF: StaffsActionTypes = 'DELETE_STAFF';

export const CREATE_MODE: AccountModalMode = 'CREATE';
export const EDIT_MODE: AccountModalMode = 'EDIT';

export const INITIAL_REQUEST: StaffRequest = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  password: '',
  confirmPassword: '',
  authorities: FEATURES.map((f: Feature) => {
    if (f === BUSINESS) {
      return {feature: f, permission: READ};
    } else {
      return {feature: f, permission: NONE};
    }
  })
};



// WEBPACK FOOTER //
// ./src/staff/Constants.tsx